import { Children, cloneElement, isValidElement, useEffect, useRef, useState } from "react"

type MapProps = google.maps.MapOptions & {
  style: { [key: string]: string }
  children?: React.ReactElement<google.maps.marker.AdvancedMarkerElement>[] | React.ReactElement<google.maps.marker.AdvancedMarkerElement>
}

export const Map: React.FC<MapProps> = ({ style, children, ...options }) => {
  const ref = useRef<HTMLDivElement>(null)
  const [map, setMap] = useState<google.maps.Map>()

  useEffect(() => {
    if (ref.current && !map) {
      const option = {
        center: options.center,
        zoom: 13,
        disableDefaultUI: true,
        zoomControl: true
      }
      setMap(new window.google.maps.Map(ref.current, option))
    }
  }, [ref, map])

  return (
    <>
      <div ref={ref} style={style} />
      {
        Children.map(children, (child) => {
          if (isValidElement(child)) {
            return cloneElement(child, { map });
          }
        })
      }
    </>
  )
}
